import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
import {useTranslation} from "react-i18next";
import parse from "html-react-parser";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  const {t} = useTranslation();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    DEVELOPMENT: t('software_solutions.categries.development'),
    MARKETING: t('software_solutions.categries.ecommerce'),
    CONSULTING: t('software_solutions.categries.consulting'),
  };

  const projectsData = [
    {
      title: t('software_solutions.services.development.title'),
      projectInfo: t('software_solutions.services.development.projectInfo'),
      technologies: t('software_solutions.services.development.technologies'),
      industry: t('software_solutions.services.development.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        github: "https://github.com/software-solutions-mx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/codigo1.png",
      sliderImages: [
        "images/projects/codigo2.png",
        "images/projects/codigo3.png",
      ],
      categories: [filters.DEVELOPMENT],
    },
    {
      title: t('software_solutions.services.microservices.title'),
      projectInfo: t('software_solutions.services.microservices.projectInfo'),
      technologies: t('software_solutions.services.microservices.technologies'),
      industry: t('software_solutions.services.microservices.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/micro1.png",
      sliderImages: [
        "images/projects/micro2.png",
        "images/projects/micro3.png",
      ],
      categories: [filters.DEVELOPMENT],
    },
    {
      title: t('software_solutions.services.systems_integration.title'),
      projectInfo: t('software_solutions.services.systems_integration.projectInfo'),
      technologies: t('software_solutions.services.systems_integration.technologies'),
      industry: t('software_solutions.services.systems_integration.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/systems1.png",
      sliderImages: [
        "images/projects/systems2.png",
        "images/projects/systems3.png",
      ],
      categories: [filters.DEVELOPMENT],
    },
    {
      title: t('software_solutions.services.hosting.title'),
      projectInfo: t('software_solutions.services.hosting.projectInfo'),
      technologies: t('software_solutions.services.hosting.technologies'),
      industry: t('software_solutions.services.hosting.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/hosting1.png",
      sliderImages: [
        "images/projects/hosting2.png",
        "images/projects/hosting3.png",
      ],
      categories: [filters.DEVELOPMENT],
    },
    {
      title: t('software_solutions.services.ecommerce.title'),
      projectInfo: t('software_solutions.services.ecommerce.projectInfo'),
      technologies: t('software_solutions.services.ecommerce.technologies'),
      industry: t('software_solutions.services.ecommerce.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/ecommerce1.png",
      sliderImages: [
        "images/projects/ecommerce2.png",
        "images/projects/ecommerce3.png",
      ],
      categories: [filters.DEVELOPMENT, filters.MARKETING],
    },
    {
      title: t('software_solutions.services.marketing.title'),
      projectInfo: t('software_solutions.services.marketing.projectInfo'),
      technologies: t('software_solutions.services.marketing.technologies'),
      industry: t('software_solutions.services.marketing.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/marketing1.png",
      sliderImages: [
        "images/projects/marketing2.png",
        "images/projects/marketing3.png",
      ],
      categories: [filters.MARKETING],
    },
    {
      title: t('software_solutions.services.graphic_design.title'),
      projectInfo: t('software_solutions.services.graphic_design.projectInfo'),
      technologies: t('software_solutions.services.graphic_design.technologies'),
      industry: t('software_solutions.services.graphic_design.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/design1.png",
      sliderImages: [
        "images/projects/design2.png",
        "images/projects/design3.png",
      ],
      categories: [filters.MARKETING],
    },
    {
      title: t('software_solutions.services.support.title'),
      projectInfo: t('software_solutions.services.support.projectInfo'),
      technologies: t('software_solutions.services.support.technologies'),
      industry: t('software_solutions.services.support.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/support1.png",
      sliderImages: [
        "images/projects/support2.png",
        "images/projects/support3.png",
      ],
      categories: [filters.CONSULTING],
    },
    {
      title: t('software_solutions.services.consulting.title'),
      projectInfo: t('software_solutions.services.consulting.projectInfo'),
      technologies: t('software_solutions.services.consulting.technologies'),
      industry: t('software_solutions.services.consulting.industry'),
      url: {
        name: "www.softwaresolutions.com.mx",
        link: "https://www.softwaresolutions.com.mx",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/softwaresolutionsmex",
        twitter: "https://twitter.com/SoftwareSolutMx",
        youtube: "https://www.youtube.com/@SoftwareSolutionsMexico",
        instagram: "https://www.instagram.com/softwaresolutionsmx",
        mail: "mailto:contacto@softwaresolutions.com.mx",
      },
      thumbImage: "images/projects/consulting1.png",
      sliderImages: [
        "images/projects/consulting2.png",
        "images/projects/consulting3.png",
      ],
      categories: [filters.CONSULTING],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Software
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              Solutions
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {parse(t('software_solutions.description'))}
          <div>
            <p>

              <span className="d-flex justify-content-center mb-5 mt-5">
                <img
                    className="img-fluid mx-auto rounded"
                    src="images/software_solutions.svg"
                    title="Software Solutions: Think - Create - Succeed"
                    alt="Software Solutions: Think - Create - Succeed"
                    width="960"
                    height="540"
                    loading="lazy"
                />
              </span>
            </p>
          </div>

          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                {t('software_solutions.categries.all')}
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt={project.title}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <button
                            type="button"
                            className="popup-ajax stretched-link btn btn-link p-0 border-0"
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            aria-label={`Ver detalles del proyecto ${project.title}`}
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
